<template>
  <campaigns-list status="draft" />
</template>

<script>
import CampaignsList from '@/modules/campaigns/components/CampaignsList'
export default {
  name: 'DraftCampaignsTab',
  components: { CampaignsList }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/DraftCampaignsTab.vue